exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".can-not-input[data-v-15b5ca97] input{pointer-events:none}.append_unit[data-v-15b5ca97]{position:relative}.append_unit[data-v-15b5ca97]:after{content:attr(data-unit);position:absolute;top:1px;right:0;padding:0 20px;color:#515a6e;background:#ebeef5;border:1px solid #dcdee2;border-radius:4px;height:36px;border-top-left-radius:0;border-bottom-left-radius:0}.el-input-number.is-without-controls .el-input__inner[data-v-15b5ca97]{text-align:left!important}", ""]);

// exports
